// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2ReRi","unreadBadge":"styles_unreadBadge__3RZv9","modalContent":"styles_modalContent__3LLuk","modal":"styles_modal__1VIHR"};